.q{width:100%;}